import { UnAssignActionModel } from './unassign-action.model';

export class UnAssignItemsModel {

    items: UnAssignActionModel[];


}
